
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Skeleton } from "@/components/ui/skeleton";
import { Button } from "@/components/ui/button";
import { RefreshCw } from "lucide-react";

export const NotificationSettingsLoading = () => {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <Skeleton className="h-8 w-32" />
        <Button variant="outline" size="sm" disabled>
          <RefreshCw className="w-4 h-4 mr-1" />
          تحديث
        </Button>
      </div>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>حالة العميل</TableHead>
            <TableHead>تفعيل</TableHead>
            <TableHead>إشعار المنشئ</TableHead>
            <TableHead>إشعار المبيعات</TableHead>
            <TableHead>إشعار الخدمة</TableHead>
            <TableHead>تأخير (دقائق)</TableHead>
            <TableHead>قالب الرسالة</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {Array.from({ length: 5 }).map((_, i) => (
            <TableRow key={i}>
              {Array.from({ length: 7 }).map((_, j) => (
                <TableCell key={j}>
                  <Skeleton className="h-8 w-full" />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
